<template lang="html">
    <div id="suggestion">
        <van-cell-group class="suggest-cnt">
            <van-cell required title="请输入您的投诉与建议"/>
            <van-field v-model="suggestionCnt" :autosize="autosize" maxlength="420" type="textarea" placeholder="输入您的意见"/>
        </van-cell-group>
        <van-cell-group>
            <van-cell>
                <ul class="uploader-files">
                    <li v-for="value in image" :key="value" class="uploader-file" @click="imagePreview(value)"></li>
                </ul>
                <van-uploader :after-read="onRead" accept="image/*" multiple>
                  <div class="upload-bg"></div>
                </van-uploader>
            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
// import { ImagePreview } from "vant";
export default {
  name: "Suggestion",
  data() {
    return {
      suggestionCnt: "",
      autosize: {
        maxHeight: 250,
        minHeight: 120
      },
      image: []
    };
  },
  methods: {
    // 图片预览
    // ImagePreview(img) {
    // const instance = ImagePreview([img]);
    // }
    // TODO:图片上传
  }
};
</script>

<style scoped lang="scss">
#suggestion {
  .suggest-cnt {
    margin-top: 1.5rem;
  }
  .uploader-files {
    .uploader-file {
      float: left;
      margin-right: 0.25rem;
      width: 79px;
      height: 79px;
    }
  }
  .upload-bg {
    width: 77px;
    height: 77px;
    border: 1px solid #d9d9d9;
    &:before {
      content: "";
      background-color: #d9d9d9;
      width: 2px;
      height: 39.5px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &:after {
      content: "";
      background-color: #d9d9d9;
      width: 39.5px;
      height: 2px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
